import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    document.addEventListener('click', this.closeMenu.bind(this))

    if (this.hasMenuTarget) {
      // Agregar las mismas clases de transición que en Flowbite
      this.menuTarget.classList.add(
        'transition-all',
        'duration-300',
        'ease-out',
        'opacity-0',
        'scale-95',
        'transform',
        'origin-top'
      )
    }
  }

  disconnect() {
    document.removeEventListener('click', this.closeMenu.bind(this))
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const buttonRect = button.getBoundingClientRect()
    const menuWidth = 224 // w-56 = 14rem = 224px
    const viewportWidth = window.innerWidth
    const scrollOffset = window.scrollX

    const wouldOverflow = buttonRect.left + menuWidth > viewportWidth
    
    this.menuTarget.style.position = 'fixed'
    this.menuTarget.style.top = `${buttonRect.bottom + window.scrollY}px`
    
    if (wouldOverflow) {
      this.menuTarget.style.left = `${buttonRect.right - menuWidth + scrollOffset}px`
      this.menuTarget.style.right = 'auto'
    } else {
      this.menuTarget.style.left = `${buttonRect.left + scrollOffset}px`
      this.menuTarget.style.right = 'auto'
    }

    document.querySelectorAll('[data-column_table_menu-target="menu"]').forEach(menu => {
      if (menu !== this.menuTarget) {
        this.hideMenu(menu)
      }
    })

    if (this.menuTarget.classList.contains('hidden')) {
      this.showMenu()
    } else {
      this.hideMenu(this.menuTarget)
    }
  }

  closeMenu(event) {
    if (!this.hasMenuTarget || this.element.contains(event.target)) return
    this.hideMenu(this.menuTarget)
  }

  showMenu() {
    this.menuTarget.classList.remove('hidden')

    requestAnimationFrame(() => {
      this.menuTarget.classList.remove('opacity-0', 'scale-95')
      this.menuTarget.classList.add('opacity-100', 'scale-100')
    })
  }

  hideMenu(menu) {
    menu.classList.remove('opacity-100', 'scale-95')
    menu.classList.add('opacity-0', 'scale-95')

    setTimeout(() => {
      menu.classList.add('hidden')
    }, 300)
  }
}
